module.exports = __webpack_public_path__ + "dist/media/logo--mute.7dba8d88.svg";